import React from 'react';
import PropTypes from 'prop-types';
import { strings, getCurrentLocale } from './../../../localization';
import EventMedia from '../../pages/dashboard/EventMedia/EventMedia';
import { getAwsS3SignedUrl } from '../../../data/media/api';
import RavenUtil from '../ravenUtil';
import { EVENT_MEDIA_STATUS, EVENT_MEDIA_REQUEST_TYPE, EVENT_MEDIA_CAMERA_TYPE } from '../../pages/dashboard/EventMedia/eventMediaConstants';

import { connect } from 'react-redux';
import ProgressOverlay from './../../../components/common/ProgressOverlay';
import { EVENT_FLAG_IDS } from '../../../data/review/duck';
import MapboxStaticImage from '../../mapbox/mapboxStaticImage/mapboxStaticImage';
import { SpeedZoneBadge } from '../speedZones/SpeedZoneBadge';
import moment from 'moment';
import SettingsSelectors from '../../../data/settings/selectors';
import FlagDropDown from './FlagDropDown';
import Protected from '../protected';
import Permissions from '../../../data/permissions';
import LocationIQStaticImage, { getLocationIQEventMarkerColor } from '../../locationIQ/locationIQStaticImage';

export const EVENT_SUMMARY_ITEM_UNIQUE_ID_PREFIX = "event-summary-item-unique-id-prefix-";
const DEFAULT_UOM = 'IMPERIAL';
const UPDATE_FLAG_TIMEOUT = 15000;

const maxNoteCharacters = 300;

class EventSummaryItemCluster extends React.PureComponent {

    static propTypes = {

        features: PropTypes.object.isRequired,
        reportItem: PropTypes.object.isRequired,
        eventItem: PropTypes.object,
        card: PropTypes.object,
        stage: PropTypes.string,

        eventId: PropTypes.string.isRequired,
        eventIdWithUnixTimestamp: PropTypes.string.isRequired,

        ravenUuid: PropTypes.string.isRequired,
        ts: PropTypes.string.isRequired,
        type: PropTypes.string.isRequired,

        eventFlags: PropTypes.object.isRequired, // for multiple flags
        eventNote: PropTypes.string,

        eventFlagPending: PropTypes.bool.isRequired,
        eventFlagChecked: PropTypes.bool,
        eventFlagErrorMessages: PropTypes.string,
        applyEventFlag: PropTypes.func.isRequired,
        timeoutEventFlag: PropTypes.func.isRequired,

        eventNotePending: PropTypes.bool.isRequired,
        eventNoteSaved: PropTypes.bool,
        eventNoteErrorMessages: PropTypes.string,
        applyEventNote: PropTypes.func.isRequired,
        timeoutEventNote: PropTypes.func.isRequired,

        unitOfMeasure: PropTypes.oneOf(['METRIC', 'IMPERIAL']).isRequired,

        profileImageComponent: PropTypes.node,

        facialRecognitionEnabled: PropTypes.bool,

        historyUrlOverride: PropTypes.string,
        TODOSHOWCASETHINGOVERRIDE: PropTypes.string,

        isWaitingForCardEventSummaries: PropTypes.bool,
    }

    constructor(props) {
        super(props);

        this.mounted = true;

        this.state = {

            selectedCameraType: EVENT_MEDIA_CAMERA_TYPE.CAMERA_ROAD,

            previewImageUrlRoad: undefined,
            previewVideoUrlRoad: undefined,
            previewVideoMediaIdRoad: undefined,

            previewImageUrlCabin: undefined,
            previewVideoUrlCabin: undefined,
            previewVideoMediaIdCabin: undefined,

            archiveVideos: [],

            eventMediaStatusRoad: EVENT_MEDIA_STATUS.CREATE_SIGNED_URL_IN_PROGRESS,
            eventMediaStatusCabin: EVENT_MEDIA_STATUS.CREATE_SIGNED_URL_IN_PROGRESS,

            eventNote: this.props.eventNote || "",
            eventFlags: this.props.eventFlags || {},

            isSummaryButtonClicked: false,
            isViewTripButtonClicked: false,

            isEditingNote: false,
        }
        this.applyEventFlagTimeoutId = undefined;
        this.applyEventNoteTimeoutId = undefined;
    }

    componentDidMount() {
        this.setState({
            eventNote: this.props.eventNote,
            eventFlags: this.props.eventFlags,
        });

        if ((this.props.eventItem)) {
            this.initializeMediaStatuses();
            this.getPreviewImageUrls();
            this.getPreviewVideoUrls();
        }

        this.adjustTextareaHeight();
    }

    componentDidUpdate(prevProps, prevState) {

        // Update the state when the props change
        if (prevProps.eventNote !== this.props.eventNote) {
            this.setState({ eventNote: this.props.eventNote });
        }

        if (prevProps.eventFlags !== this.props.eventFlags) {
            this.setState({ eventFlags: this.props.eventFlags }, () => {
            });
        }

        if (this.props.eventFlags !== this.state.eventFlags) {
            this.setState({ eventFlags: this.props.eventFlags }, () => {
            });
        }

        // onload fallback for componentDidMount trigger:
        if ((!prevProps.eventItem && this.props.eventItem)) {
            this.initializeMediaStatuses();
            this.getPreviewImageUrls();
            this.getPreviewVideoUrls();
        }

        // on reuse
        if (prevProps.eventId !== this.props.eventId) {
            this.setState({
                previewImageUrlRoad: undefined,
                previewVideoUrlRoad: undefined,
                previewVideoMediaIdRoad: undefined,

                previewImageUrlCabin: undefined,
                previewVideoUrlCabin: undefined,
                previewVideoMediaIdCabin: undefined,

                archiveVideos: [],

                eventMediaStatusRoad: EVENT_MEDIA_STATUS.CREATE_SIGNED_URL_IN_PROGRESS,
                eventMediaStatusCabin: EVENT_MEDIA_STATUS.CREATE_SIGNED_URL_IN_PROGRESS
            });
            if (this.props.eventItem) {
                this.initializeMediaStatuses();
                this.getPreviewImageUrls();
                this.getPreviewVideoUrls();
            }
        }

        this.adjustTextareaHeight();
    }

    componentWillUnmount() {
        this.mounted = false;
        this.setState({
            previewImageUrlRoad: undefined,
            previewVideoUrlRoad: undefined,
            previewVideoMediaIdRoad: undefined,

            previewImageUrlCabin: undefined,
            previewVideoUrlCabin: undefined,
            previewVideoMediaIdCabin: undefined,

            archiveVideos: [],

            eventMediaStatusRoad: EVENT_MEDIA_STATUS.CREATE_SIGNED_URL_IN_PROGRESS,
            eventMediaStatusCabin: EVENT_MEDIA_STATUS.CREATE_SIGNED_URL_IN_PROGRESS,

            isSummaryButtonClicked: false,
            isViewTripButtonClicked: false,
        });
        clearTimeout(this.applyEventFlagTimeoutId);
        clearTimeout(this.applyEventNoteTimeoutId);
    }

    handleArchiveVideoError = (videoIndex, mediaId, error) => {
        console.error(`EventSummaryItemCluster archive video ${videoIndex} error`, error);
        this.setState(prevState => {
            const updatedVideos = [...prevState.archiveVideos];
            if (updatedVideos[videoIndex]) {
                updatedVideos[videoIndex] = {
                    ...updatedVideos[videoIndex],
                    status: EVENT_MEDIA_STATUS.ERROR_PLAYBACK_FAILED,
                    // url preserved intentionally so download remains available
                };
            }
            return { archiveVideos: updatedVideos };
        });
    }

    handleClearPlaybackError = (videoIndex) => {
        this.setState(prevState => {
            const updatedVideos = [...prevState.archiveVideos];
            if (updatedVideos[videoIndex]) {
                updatedVideos[videoIndex] = {
                    ...updatedVideos[videoIndex],
                    status: EVENT_MEDIA_STATUS.PREVIEW_VIDEO_AVAILABLE,
                };
            }
            return { archiveVideos: updatedVideos };
        });
    }

    handleSummaryClick = (e) => {
        this.setState({ isSummaryButtonClicked: true });
    }

    handleViewTripClick = (e) => {
        this.setState({ isViewTripButtonClicked: true });
    }

    handleFlagChange = (e, flagName) => {
        const checked = e.target.checked;
        const { ravenUuid, eventIdWithUnixTimestamp } = this.props;
        const newEventFlags = { ...this.state.eventFlags };

        clearTimeout(this.applyEventFlagTimeoutId);  // clear any existing timeout

        this.applyEventFlagTimeoutId = setTimeout(() => {
            this.props.timeoutEventFlag(checked, ravenUuid, eventIdWithUnixTimestamp, newEventFlags);
        }, UPDATE_FLAG_TIMEOUT);

        this.props.applyEventFlag(this.props.stage, checked, ravenUuid, eventIdWithUnixTimestamp, flagName, newEventFlags)
            .then(
                () => { clearTimeout(this.applyEventFlagTimeoutId); },
                () => { clearTimeout(this.applyEventFlagTimeoutId); }
            );
        newEventFlags[EVENT_FLAG_IDS[flagName]] = checked; // Update the new flags object with the new flag value
        // Update the state with the new event flags
        this.setState({ 
            eventFlags: newEventFlags,
        });
    };

    handleInputChange = (e) => {
        const inputText = e.target.value;
        if (inputText.length <= maxNoteCharacters) {
            this.setState({ eventNote: inputText });
        }
        this.adjustTextareaHeight();
    }

    adjustTextareaHeight() {
        if (this.textarea) {
            this.textarea.style.height = "auto"; // Reset height
            this.textarea.style.height = `${this.textarea.scrollHeight}px`; // Adjust to content
        }
    }

    handleDeleteClick = () => {

        const { ravenUuid, eventIdWithUnixTimestamp, eventNoteSaved } = this.props;
        this.setState({ eventNote: "" });

        clearTimeout(this.applyEventNoteTimeoutId);

        this.applyEventNoteTimeoutId = setTimeout(() => {
            this.props.timeoutEventNote(eventNoteSaved, ravenUuid, eventIdWithUnixTimestamp, "");
        }, UPDATE_FLAG_TIMEOUT);

        this.props.applyEventNote(this.props.stage, !eventNoteSaved, ravenUuid, eventIdWithUnixTimestamp, "")
            .then(
                () => { clearTimeout(this.applyEventNoteTimeoutId) },
                () => { clearTimeout(this.applyEventNoteTimeoutId) }
            );
    }

    handleSaveClick = () => {

        const { ravenUuid, eventIdWithUnixTimestamp, eventNoteSaved } = this.props;
        const { eventNote } = this.state;

        clearTimeout(this.applyEventNoteTimeoutId);

        this.applyEventNoteTimeoutId = setTimeout(() => {
            this.props.timeoutEventNote(eventNoteSaved, ravenUuid, eventIdWithUnixTimestamp, eventNote);
        }, UPDATE_FLAG_TIMEOUT);

        this.props.applyEventNote(this.props.stage, !eventNoteSaved, ravenUuid, eventIdWithUnixTimestamp, eventNote)
            .then(
                () => { clearTimeout(this.applyEventNoteTimeoutId) },
                () => { clearTimeout(this.applyEventNoteTimeoutId) }
            );
    }

    initializeMediaStatuses = () => {

        let eventMediaStatusRoad = this.state.eventMediaStatusRoad;
        let eventMediaStatusCabin = this.state.eventMediaStatusCabin;

        let previewMediaRoad;
        let previewMediaCabin;

        if (this.props.eventItem) {
            for (let i = 0; i < this.props.eventItem.mediaList.length; i += 1) {
                if (previewMediaRoad && previewMediaCabin) {
                    break;
                }
                if (this.props.eventItem.mediaList[i].type === "MEDIA_PREVIEW") {
                    if (this.props.eventItem.mediaList[i].cameraType === EVENT_MEDIA_CAMERA_TYPE.CAMERA_ROAD) {
                        previewMediaRoad = this.props.eventItem.mediaList[i];
                    } else {
                        previewMediaCabin = this.props.eventItem.mediaList[i];
                    }
                }
            }
        }

        let previewVideoMediaIdRoad = this.state.streamingArchiveUrl ? this.state.streamingArchiveMediaId : this.state.previewVideoMediaIdRoad;
        let previewVideoMediaIdCabin = this.state.streamingArchiveUrl ? undefined : this.state.previewVideoMediaIdCabin;

        if (this.props.eventItem) {
            if (!previewMediaRoad && !previewVideoMediaIdRoad) {
                eventMediaStatusRoad = EVENT_MEDIA_STATUS.NOT_FOUND_PREVIEW_IMAGE;
            }

            if (!previewMediaCabin && !previewVideoMediaIdCabin) {
                eventMediaStatusCabin = EVENT_MEDIA_STATUS.NOT_FOUND_PREVIEW_IMAGE;
            }
        }

        this.setState({
            eventMediaStatusRoad: eventMediaStatusRoad,
            eventMediaStatusCabin: eventMediaStatusCabin
        });
    }

    getPreviewImageUrls = () => {

        const eventMediaList = this.props.eventItem ? this.props.eventItem.mediaList : [];

        for (let i = 0; i < eventMediaList.length; i += 1) {

            if (eventMediaList[i].type === "MEDIA_PREVIEW") {

                if (!eventMediaList[i].url) continue;

                getAwsS3SignedUrl({ key: eventMediaList[i].url }).then((res) => {
                    if (!this.mounted) {
                        return;
                    }
                    if (eventMediaList[i].cameraType === EVENT_MEDIA_CAMERA_TYPE.CAMERA_ROAD) {
                        this.setState({
                            previewImageUrlRoad: res.url,
                            previewVideoMediaIdRoad: eventMediaList[i].mediaId
                        });
                    } else {
                        this.setState({
                            previewImageUrlCabin: res.url,
                            previewVideoMediaIdCabin: eventMediaList[i].mediaId
                        });
                    }
                });
            }
        }
    }

    getPreviewVideoUrls = () => {

        const eventMediaList = this.props.eventItem ? this.props.eventItem.mediaList : [];

        if (!eventMediaList) {
            return;
        }

        // Collect all archive videos with metadata
        const archiveVideos = [];

        for (let i = 0; i < eventMediaList.length; i += 1) {

            if (eventMediaList[i].type === "MEDIA_PREVIEW_VIDEO" || 
                eventMediaList[i].type === "MEDIA_STREAMING_ARCHIVE") {
                
                if (!eventMediaList[i].url) continue;
                
                // Add to archive videos array instead of processing immediately
                archiveVideos.push({
                    mediaItem: eventMediaList[i],
                    timestamp: eventMediaList[i].timestamp || eventMediaList[i].ts || Date.now(),
                    mediaId: eventMediaList[i].mediaId,
                    status: EVENT_MEDIA_STATUS.CREATE_SIGNED_URL_IN_PROGRESS
                });
            }
        }

        // Sort by timestamp
        archiveVideos.sort((a, b) => new Date(a.timestamp) - new Date(b.timestamp));
        
        // Set initial state with metadata
        this.setState({ archiveVideos });
        
        // Process signed URLs for each video
        archiveVideos.forEach((videoItem, index) => {
            getAwsS3SignedUrl({ key: videoItem.mediaItem.url }).then((res) => {
                if (!this.mounted) return;
                
                this.setState(prevState => {
                    const updatedVideos = [...prevState.archiveVideos];
                    if (updatedVideos[index]) {
                        updatedVideos[index] = {
                            ...updatedVideos[index],
                            url: res.url,
                            status: EVENT_MEDIA_STATUS.PREVIEW_VIDEO_AVAILABLE
                        };
                    }
                    return { archiveVideos: updatedVideos };
                });
            }).catch((error) => {
                if (!this.mounted) return;
                
                this.setState(prevState => {
                    const updatedVideos = [...prevState.archiveVideos];
                    if (updatedVideos[index]) {
                        updatedVideos[index] = {
                            ...updatedVideos[index],
                            status: EVENT_MEDIA_STATUS.ERROR
                        };
                    }
                    return { archiveVideos: updatedVideos };
                });
            });
        });
    }

    getEventMarkerColor = (eventType) => {
        switch (eventType) {
            case 'EVENT_ENGINE_ON':
            case 'EVENT_ENGINE_OFF':
                return '4A8E16'; // $green-dark
            case 'EVENT_SPEEDING_STARTED':
            case 'EVENT_SPEEDING_STOPPED':
            case 'EVENT_IDLING_STARTED': 
            case 'EVENT_IDLING_STOPPED':
            case 'EVENT_HARD_BRAKING':
            case 'EVENT_OBD_DTC_ALERT':
            case 'EVENT_OBD_DTC_CLEARED':
            case 'EVENT_ACCIDENT':
            case 'EVENT_POSSIBLE_IMPACT':
            case 'EVENT_RAVEN_BAD_INSTALL_DETECTED':
            case 'EVENT_RAVEN_BAD_INSTALL_CLEARED':
                return 'C22626'; // $red-dark
            case 'EVENT_RAVEN_GEOFENCE_ENTER':
            case 'EVENT_RAVEN_GEOFENCE_EXIT':
                return '6E6E6E'; // $grey-medium-dark
            default:
                return 'A48229'; // $yellow-dark
        }

    }

    expandTheCluster = (e) => {
        e.preventDefault();
        const closestEventSummaryItemCluster = e.currentTarget.closest('.event-summary-item-cluster');
        if (closestEventSummaryItemCluster) {
            closestEventSummaryItemCluster.classList.toggle('expanded');
        }
    }

    render() {
        let eventDate;
        let eventName;
        let vehicleName;
        let driverName;
        let eventElementUniqueId;

        let unitOfMeasure = DEFAULT_UOM;
        if (this.props.unitOfMeasure) {
            unitOfMeasure = this.props.unitOfMeasure.toUpperCase();
        }

        const summaryButtonClass = this.state.isSummaryButtonClicked ? "btn btn-sm btn-outline-blue" : "btn btn-sm btn-outline-black";
        const viewTripButtonClass = this.state.isViewTripButtonClicked ? "btn btn-sm btn-outline-blue" : "btn btn-sm btn-outline-black";

        if (this.props.reportItem) {
            eventDate = RavenUtil.toDate(this.props.reportItem["FactEvent.timestamp"]);
            eventName = document.getEventName({ type: this.props.reportItem["DimEventType.name"] });
            vehicleName = this.props.reportItem["DimVehicle.name"];
            driverName = this.props.reportItem["DimDriver.name"];
            eventElementUniqueId = EVENT_SUMMARY_ITEM_UNIQUE_ID_PREFIX + this.props.eventId;
        }

        let tripHistoryHref = "/" + getCurrentLocale() + "/stats/history/";
        if (this.props.historyUrlOverride) {
            tripHistoryHref = this.props.historyUrlOverride; // showcase
        } else if (this.props.reportItem) {
            tripHistoryHref += this.props.reportItem["DimRaven.uuid"] + "/" + this.props.reportItem["DimCard.cardId"];
        }

        let eventReportHref = "/" + getCurrentLocale() + "/stats/history/";
        if (this.props.TODOSHOWCASETHINGOVERRIDE) {
            eventReportHref = this.props.TODOSHOWCASETHINGOVERRIDE; // showcase
        } else if (this.props.reportItem) {
            eventReportHref += this.props.reportItem["DimRaven.uuid"] + "/" + this.props.reportItem["DimCard.cardId"] + "/" + this.props.eventId;
            const hasEventNote = this.props.eventNote && this.props.eventNote.length > 0;
            const hasEventFlags = this.props.eventFlags && Object.values(this.props.eventFlags).some(flag => flag);

            if (hasEventNote || hasEventFlags) {
                eventReportHref += "?";
                if (hasEventNote) {
                    eventReportHref += "note=" + encodeURIComponent(this.props.eventNote);
                }
                if (hasEventFlags) {
                    if (hasEventNote) {
                        eventReportHref += "&";
                    }
                    eventReportHref += "flags=" + Object.keys(this.props.eventFlags).filter(flag => this.props.eventFlags[flag]).join(",");
                }
            }
        }

        const eventType = this.props.eventItem ? this.props.eventItem.type : undefined;
        let eventBadgeComponent;
        switch (eventType) {
            case "EVENT_KLOUD_LIVE_STREAMING":
            case "EVENT_KLOUD_HISTORICAL_STREAMING":
                break;

            case "EVENT_SPEEDING_STARTED":
                if(!this.props.card) break; // no speed zone data without card
                const speedZone = RavenUtil.getSpeedzoneForEvent(this.props.card, this.props.eventItem);
                if (speedZone) {
                    const speedLimit = speedZone.speedLimit;
                    const maxSpeed = speedZone.maxSpeed;
                    const startTime = speedZone.startTime;
                    const startDate = new Date(startTime);
                    const endTime = speedZone.endTime;
                    const endDate = new Date(endTime);

                    if (!speedLimit) {
                        console.error("eventScrollableList createEventList speeding event, speedZone invalid speedLimit", speedZone);
                    } else if (!maxSpeed) {
                        console.error("eventScrollableList createEventList speeding event, speedZone invalid maxSpeed", speedZone);
                    } else if (!startTime) {
                        console.error("eventScrollableList createEventList speeding event, speedZone invalid startTime", speedZone);
                    } else if (!endTime) {
                        console.error("eventScrollableList createEventList speeding event, speedZone invalid endTime", speedZone);
                    } else {
                        eventBadgeComponent = (
                            <SpeedZoneBadge
                                speedLimit={speedLimit}
                                maxSpeed={maxSpeed}
                                startDate={startDate}
                                endDate={endDate}
                                unitOfMeasure={unitOfMeasure}
                            />
                        );
                    }
                }
                break;
            default:
                break;
        }

        const lat = this.props.eventItem && this.props.eventItem.geoStamp && this.props.eventItem.geoStamp.lat ? this.props.eventItem.geoStamp.lat : 0;
        const lon = this.props.eventItem && this.props.eventItem.geoStamp && this.props.eventItem.geoStamp.lon ? this.props.eventItem.geoStamp.lon : 0;

        const hasGPSData = (lat !== 0 && lon !== 0);

        const markerColor = this.getEventMarkerColor(this.props.type);
        const locationIQMarkerColor = getLocationIQEventMarkerColor(this.props.type);

        const options = Object.keys(EVENT_FLAG_IDS).map((flagName) => ({
            value: flagName,
            label: strings[flagName.toLowerCase() + '_label'],
            checked: this.state.eventFlags[EVENT_FLAG_IDS[flagName]] || false,
        }));

        const anyFlagIsChecked = options.some(flag => flag.checked);
        const noteFieldPlaceholder = anyFlagIsChecked ? strings.event_note_label : strings.event_note_label_first_select_flags;

        const noStatusApplied = !Object.values(this.state.eventFlags).some(flag => flag);
        const highlightRedEventType = (this.props.type === "EVENT_HARD_BRAKING" || this.props.type === "EVENT_SPEEDING_STARTED" || this.props.type === "EVENT_POSSIBLE_IMPACT");
        const firstVideo = this.state.archiveVideos.length > 0 ? this.state.archiveVideos[0] : null;
        const otherVideos = this.state.archiveVideos.slice(1);
        
        let mediaRequestType = EVENT_MEDIA_REQUEST_TYPE.NONE;
        if(this.props.features?.media_request && this.props.canRequestMedia) {
            mediaRequestType = EVENT_MEDIA_REQUEST_TYPE.USER_MEDIA_REQUEST;
        }

        return (
            <div className={"event-summary-item event-summary-item-cluster fr"} id={eventElementUniqueId}>
                <div className="info">
                    <span className="summary-item-label label-bold">{vehicleName}</span>
                    <span className={`summary-item-label label-bold + ${highlightRedEventType ? "event-highlight" : ""}`}><strong>{eventName}</strong></span>
                    <span className="summary-item-label">{(eventDate ? moment(eventDate).format("LL - LT") : null)}</span>
                </div>
                <div className="details">
                    <div className="display-details">
                        <div className="details-field">
                            <div className="summary-wrapper">
                                <div className="actions">
                                    <a href={eventReportHref} target="_blank" rel="noopener noreferrer" className={summaryButtonClass} onClick={this.handleSummaryClick}>
                                        {strings.action_summary}
                                    </a>
                                    <a href={tripHistoryHref} target="_blank" rel="noopener noreferrer" className={viewTripButtonClass} onClick={this.handleViewTripClick}>
                                        {strings.action_view_trip}
                                    </a>
                                </div>
                                <div className="feature">{eventBadgeComponent}</div>
                            </div>
                            <div className="driver-wrapper">                                
                                {this.props.profileImageComponent}
                                {this.props.features && this.props.features.facial_recognition && this.props.facialRecognitionEnabled ?
                                    <span className="driver-label">{driverName ? driverName : strings.unknown}</span>
                                    :
                                    <span></span>
                                }
                            </div>
                            <Protected resource="coaching" action="write">
                                <div className="flag-wrapper">
                                    <FlagDropDown options={options} onChange={this.handleFlagChange} isPending={this.props.eventFlagPending}/>
                                    <div className="flag-display">
                                        {noStatusApplied ? strings.event_flag_no_status_applied_label : (
                                            <span>
                                                <span className="bold-label">{strings.event_flag_status_label}</span>
                                                {options.filter(flag => flag.checked).map(flag => flag.label).join(', ')}
                                            </span>
                                        )}
                                    </div>
                                </div>
                            </Protected>
                        </div>
                        <Protected resource="coaching" action="write">
                            <div className="note-field">
                                <textarea disabled={!anyFlagIsChecked} className="note-area" ref={(textarea) => (this.textarea = textarea)} placeholder={noteFieldPlaceholder} value={this.state.eventNote} onChange={this.handleInputChange} onFocus={() => this.setState({ isEditingNote: true })} maxLength={maxNoteCharacters} />
                                <div className="note-details">
                                    <span className="note-limit">{this.state.eventNote.length}/{maxNoteCharacters}</span>
                                    {(this.state.isEditingNote == true && this.state.eventNote.length == maxNoteCharacters) ? <span className="note-limit-error">{strings.formatString(strings.event_note_max_characters_error, maxNoteCharacters)}</span> : null}
                                </div>
                                <div className='note-actions'>
                                    <button disabled={!anyFlagIsChecked} className="btn btn-sm btn-outline-black save-note" onClick={this.handleSaveClick}>{strings.action_save_note}</button>
                                    <button disabled={!anyFlagIsChecked} className='delete-note' onClick={this.handleDeleteClick}><i className="material-icons">delete_forever</i></button>
                                </div>
                            </div>
                        </Protected>
                    </div>
                    {this.props.eventNotePending || this.props.eventFlagPending ? <ProgressOverlay /> : null}
                </div>
                <div className="multi-panel-wrapper">
                    {/* Render multiple archive videos vertically */}
                    <EventMedia
                        key={`archive-video-${firstVideo?.mediaId || 0}`}
                        shouldShowAlternateCameraType={false}
                        
                        // Video-specific state:
                        previewImageUrl={undefined} // No preview images for archive videos
                        previewVideoUrl={firstVideo?.url}
                        status={firstVideo?.status}

                        // Static props:
                        eventId={this.props.eventId}
                        eventType={this.props.eventItem ? this.props.eventItem.type : undefined}
                        date={this.props.eventItem ? RavenUtil.toDate(this.props.eventItem.ts) : undefined}
                        
                        cameraType={EVENT_MEDIA_CAMERA_TYPE.CAMERA_ROAD} // Default for archive videos
                        previewVideoCameraType={EVENT_MEDIA_CAMERA_TYPE.CAMERA_ROAD}
                        mediaRequestType={mediaRequestType}
                        createEventUserVideo={undefined}
                        toggleCamera={undefined}
                        onVideoError={(mediaId, error) => this.handleArchiveVideoError(0, mediaId, error)}
                        clearPlaybackError={() => this.handleClearPlaybackError(0)}
                        autoPlay={true} // Only autoplay first video
                        offline={true}
                    />
                    <div className="col-12 image-panel panel-wrapper">
                        
                    </div>
                    <LocationIQStaticImage
                        width={1000}
                        height={600}
                        marker={{ latitude: lat, longitude: lon, color: locationIQMarkerColor }}
                        points={this.props.card ? this.props.card.route : undefined}
                        hasGPSData={hasGPSData}
                        defaultTheme={this.props.features.theme_selection ? this.props.features.theme_selection : 'light'}
                        isWaitingForGPSData={this.props.isWaitingForCardEventSummaries || !this.props.card} // To generate the static map, we need to wait for the GSP data & card.routes to be available
                    />

                    { otherVideos.length > 0 && 
                    <div className='more-videos'>
                        <div className="see-all-videos">
                            <button className='btn btn-expand btn-blue btn-sm' onClick={this.expandTheCluster}>
                                <i className="material-icons">expand_more</i> {strings.formatString(strings.event_see_more_videos, otherVideos.length)}
                            </button>
                            <button className='btn btn-collapse btn-blue btn-sm' onClick={this.expandTheCluster}>
                                <i className="material-icons">expand_less</i> {strings.event_hide_videos}
                            </button>
                        </div>
                        {otherVideos.map((videoItem, index) => (
                            <EventMedia
                                key={`archive-video-${videoItem.mediaId || index}`}
                                shouldShowAlternateCameraType={false}

                                // Video-specific state:
                                previewImageUrl={undefined} // No preview images for archive videos
                                previewVideoUrl={videoItem.url}
                                status={videoItem.status}

                                // Static props:
                                eventId={this.props.eventId}
                                eventType={this.props.eventItem ? this.props.eventItem.type : undefined}
                                date={this.props.eventItem ? RavenUtil.toDate(this.props.eventItem.ts) : undefined}

                                cameraType={EVENT_MEDIA_CAMERA_TYPE.CAMERA_ROAD} // Default for archive videos
                                previewVideoCameraType={EVENT_MEDIA_CAMERA_TYPE.CAMERA_ROAD}
                                mediaRequestType={mediaRequestType}
                                createEventUserVideo={undefined}
                                toggleCamera={undefined}
                                onVideoError={(mediaId, error) => this.handleArchiveVideoError(index + 1, mediaId, error)}
                                clearPlaybackError={() => this.handleClearPlaybackError(index + 1)}
                            />
                        ))}
                    </div>
                    }
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        unitOfMeasure: SettingsSelectors.unitOfMeasure(state),
        canRequestMedia: Permissions.selectors.can(state, 'ravens.media', 'request', { resourceId: ownProps.ravenUuid }),
    };
}

export {EventSummaryItemCluster as UnconnectedEventSummaryItemCluster}; // Added for testing
export default connect(mapStateToProps)(EventSummaryItemCluster);